import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { DynamicFormLayout } from '../../../core/models/dynamic-form.models';
import { DynamicSectionComponent } from '../dynamic-section/dynamic-section';


@Component({
  selector: 'app-dynamic-form-shell',
  standalone: true,
  // changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReactiveFormsModule, DynamicSectionComponent],
  templateUrl: './dynamic-form-shell.html'
})
export class DynamicFormShellComponent {
  @Input() layout!: DynamicFormLayout;
  @Input() form!: FormGroup;
  getCurrentDate(): string {
  return new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}
}